import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { UserInfoDialogComponent } from '../components/user-info-dialog/user-info-dialog.component';
import { UsersService } from './users-service.service';

/**
 * Opens the one profile dialog the admin has, for a uid.
 *
 * The users list opens it with a row it already holds; every other board -
 * abuse case, events - has only a uid and fetches the row first. That fetch
 * and the dialog options were about to be copied a third time, so they live
 * here once. Rejects with a message fit to show, so callers set their own
 * error line without knowing what a 404 means.
 *
 * Resolves to the open dialog, for a caller that wants it in a particular
 * state - the outreach page opens the team composer after a takeover.
 */
@Injectable({ providedIn: 'root' })
export class ProfileDialogService {
  constructor(private usersService: UsersService, private dialog: MatDialog) {}

  async open(uid: string): Promise<MatDialogRef<UserInfoDialogComponent>> {
    let user;
    try {
      user = await firstValueFrom(this.usersService.getUserForAdmin(uid));
    } catch (err: any) {
      throw new Error(
        err?.status === 404
          ? 'No profile for this account in Postgres — it may never have finished signing up.'
          : `Could not load the profile: ${err?.message ?? err}`
      );
    }
    return this.dialog.open(UserInfoDialogComponent, {
      width: '880px',
      maxWidth: '96vw',
      autoFocus: false,
      data: user,
    });
  }
}
